import type {
  ClaimInviteAccountRequest,
  ClaimInviteAccountResponse,
  InvitePreview,
  SendInviteRequest,
  SendInviteResponse,
  Player,
} from '@swiss-magic/shared-types';
import { post, publicGet, publicPost } from './core';

export function sendInvite(
  tournamentId: string,
  playerId: string,
  email: string,
  locale: string,
): Promise<SendInviteResponse> {
  const body: SendInviteRequest = { email, locale };
  return post(`/tournaments/${tournamentId}/players/${playerId}/invite`, body);
}

export function getInvitePreview(token: string): Promise<InvitePreview> {
  return publicGet(`/invite/${token}/preview`);
}

export function acceptInvite(token: string): Promise<Player> {
  return post(`/invite/${token}/accept`);
}

export function claimInviteAccount(
  token: string,
  password: string,
): Promise<ClaimInviteAccountResponse> {
  const body: ClaimInviteAccountRequest = { password };
  return publicPost(`/invite/${token}/claim-account`, body);
}
